import { Link } from "react-router-dom";
import { useCustomers } from "../hooks/useCustomers";
import Loading from "@/components/fragments/Loadin";
import Error from "@/components/fragments/Error";
import { Button } from "@/components/ui/button";
import { getStoredUserData } from "@/utils/getStoredUser";

export default function CustomerBase() {
  const userData = getStoredUserData();
  const email = userData?.email || "";
  const { data: customers, isLoading, error } = useCustomers(email);

  // Array warna untuk icon background (bergilir)
  const iconBgColors = ["#d7d0fe", "#ffecba", "#efecfa", "#efecff"];

  if (isLoading) {
    return <Loading fullScreen message="Loading..." size="large" />;
  }

  if (error) {
    return <Error error={error} showBackButton fullScreen />;
  }

  return (
    <div className="container px-4 py-8 mx-auto">
      {/* Header */}
      <div className="flex items-center justify-end mb-6">
        <Link to="/customer/add">
          <Button variant="outline">Tambah Customer</Button>
        </Link>
      </div>

      {/* Empty State */}
      {!customers || customers.length === 0 ? (
        <div className="w-full min-h-50 flex items-center justify-center bg-[#efecfa] p-4 rounded-lg dark:bg-transparent">
          <p className="text-[#1e1e1e] dark:text-white dark:text-white text-sm">
            Tidak ada customer
          </p>
        </div>
      ) : (
        /* Customer List */
        <div className="space-y-2">
          {customers.map((customer, index) => (
            <Link
              key={customer.cust_id}
              to={`/customer/${customer.cust_id}`}
              className="block"
            >
              <div className="rounded-full p-1.5 bg-[#f9f8fd] hover:bg-white hover:scale-105 transition-all cursor-pointer duration-200 dark:bg-[#1b1b1b]">
                <div className="flex items-center">
                  {/* Icon with rotating background colors */}
                  <div className="mr-3">
                    <div
                      className="flex items-center justify-center w-12 h-12 transition-colors rounded-full"
                      style={{
                        backgroundColor:
                          iconBgColors[index % iconBgColors.length],
                      }}
                    >
                      <span className="text-2xl font-bold text-[#1e1e1e] dark:text-white">
                        👤
                      </span>
                    </div>
                  </div>

                  {/* Customer Info */}
                  <div className="flex-1">
                    <p className="text-[#1e1e1e] dark:text-white font-medium">
                      {customer.cust_name}
                    </p>
                    <div className="flex items-center gap-3 mt-0.5">
                      <p className="text-[#1e1e1e] dark:text-white font-light text-xs">
                        ID: {customer.cust_id}
                      </p>
                      <span className="text-[#1e1e1e] dark:text-white">•</span>
                      <p className="text-[#1e1e1e] dark:text-white font-light text-xs">
                        {customer.cust_phone}
                      </p>
                    </div>
                  </div>

                  {/* Action Icon */}
                  <div className="ml-3">
                    <div className="flex items-center justify-center w-12 h-12 rounded-full">
                      <span className="text-[#1e1e1e] dark:text-white text-xl font-bold">
                        ∘∘∘
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
